import { Gizmo } from '../../gizmos';
import CommonBinder from '../common-binder';

interface IRowBinder {
  init(): Promise<void>;
}

class RowBinder extends CommonBinder implements IRowBinder {
  constructor(gizmo: Gizmo) {
    super(gizmo);
  }

  public init = (): Promise<void> => {
    return new Promise<void>(async resolve => {
      resolve();
    });
  };
}

export default RowBinder;
